<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="3%")
          span #
        th(width="6%")
          span(:title="$t('ui.id')") {{ $t('ui.id') }}
        th(width="6%")
          span(:title="$t('ui.ref_no')") {{ $t('ui.ref_no') }}
        template(v-if="operatorView == false")
          th(width="6%")
            span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
        th(width="6%")
          span(:title="$t('ui.member')") {{ $t('ui.member') }}
        th(width="6%")
          span(:title="$t('ui.bank_acc_holder')") {{ $t('ui.bank_acc_holder') }}
        th(width="6%")
          span(:title="$t('ui.mode')") {{ $t('ui.mode') }}
        th.text-right(width="6%")
          span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
        th.text-right(width="6%")
          span(:title="$t('ui.exchanged_amount')") {{ $t('ui.exchanged_amount') }}
        th(width="6%")
          span(:title="$t('ui.promo')") {{ $t("ui.promo") }}
        th.text-right(width="6%")
          span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
        th(width="6%")
          span(:title="$t('ui.upline')") {{ $t("ui.upline") }}
        th(width="6%")
          span(:title="$t('ui.vip')") {{ $t("ui.vip") }}
        th.text-center(width="5%")
          span(:title="$t('ui.status')") {{ $t("ui.status") }}
        th(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'" width="5%")
          span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
        th(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'" width="5%")
          span(:title="$t('ui.modified_by')") {{ $t("ui.modified_by") }}
        th.text-right(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'" width="8%")
          span(:title="$t('ui.deposit_time')") {{ $t("ui.deposit_time") }}
        th.text-right(width="8%")
          span(:title="$t('ui.submit_time')") {{ $t("ui.submit_time") }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(:colspan="ticketStatus.trim().toUpperCase() != 'PENDING' ? '16' : '13'").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl" :class="$helpers.rowClassTicket(item, 'deposit')")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td
          span.d-block(:title="item.id") {{ item.id }}&nbsp;
        td
          span.small.text-info.d-block(:title="getRefNo(item.target_bank_id, item.id, item.prefix_d, item.prefix_delimiter)") {{ getRefNo(item.target_bank_id, item.id, item.prefix_d, item.prefix_delimiter) }}&nbsp;
        template(v-if="operatorView == false")
          td
            span(:title="item.parent_id") {{ item.parent_id }}&nbsp;
        td
          span(:title="item.member_id") {{ item.member_id }}&nbsp;
        td
          span(:title="item.target_bank_acc_holder") {{ item.target_bank_acc_holder }}&nbsp;
        td
          span(:title="item.deposit_method") {{ item.deposit_method }}&nbsp;
          span.text-danger(v-if="item.rate != null && item.rate_php != null") ({{ item.rate }}/{{ item.rate_php }})
        td.text-right
          span.font-weight-bold.d-block(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
        td.text-right
          span.font-weight-bold.d-block(:class="{'text-danger': item.exchanged_amount > 0  }" v-if="item.exchanged_amount != null" :title="$n(item.exchanged_amount, 'currency')") {{ $n(item.exchanged_amount, 'currency') }}
        td
          span(:title="item.promotion_id") {{ item.promotion_id }}&nbsp;
        td
          span.font-weight-bold.d-block(:title="$n(item.bonus_amount, 'currency')" :class="$helpers.fontClassName(item.bonus_amount)") {{ $n(item.bonus_amount, 'currency') }}
        td
          span(:title="item.referrer_id") {{ item.referrer_id }}&nbsp;
        td
          span(:title="item.vip_name") {{ item.vip_name }}&nbsp;
        td.text-center
          span(v-if="item.status.trim().toUpperCase() != 'REJECTED'" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
          template(v-if="item.status.trim().toUpperCase() == 'REJECTED' && item.reject_onload == false")
            span(:class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
          template(v-if="item.status.trim().toUpperCase() == 'REJECTED' && item.reject_onload == true")
            span(:class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
            span.d-block.text-danger ({{ $t('ui.onload').toUpperCase() }})
        td(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
          span(:title="item.remark") {{ item.remark }}&nbsp;
        td(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
          span(:title="item.modified_by") {{ item.modified_by }}&nbsp;
        td.text-right(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
          span(v-if="item.modified_date" :title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_date).format("YYYY-MM-DD, HH:mm:ss") }}
        td.text-right
          span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
    ticketStatus: {
      type: String,
      default: ""
    },
    operatorView: {
      type: Boolean,
      default: true
    },
  },
  methods: {
    getRefNo: function(bank_id, id, prefix, delimiter) {
      return this.$helpers.getPaymentGatewayRefNoSetMember(bank_id, id, prefix, delimiter);
    },
  }
};
</script>
